var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.2602 5.57208L9.42562 2.50822C8.57984 1.83529 7.39883 1.8359 6.55121 2.50945L2.74305 5.5647C2.27864 5.91777 2.00738 6.45353 2 7.03975V12.93C2 13.5218 2.48102 14.0028 3.07275 14.0028H5.19549H10.8188H12.9219C13.5136 14.0028 13.9946 13.5218 13.9946 12.93V7.03237C13.9848 6.45291 13.7055 5.90362 13.2602 5.57208Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26562 12.9305C6.26562 13.5223 6.26562 14.0033 6.26562 14.0033H9.74343C9.74343 14.0033 9.74343 13.5223 9.74343 12.9305V10.774C9.74343 10.2911 9.5509 9.84208 9.20091 9.50992C8.85153 9.17899 8.38835 9.01045 7.90918 9.03567C7.00312 9.08365 6.26562 9.91836 6.26562 10.8964V12.9305Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bfd552383b371a2b3b99cb73c840706e.svg";
export { ForwardRef as ReactComponent };